import db from "../Db";
import { handleError } from "../Function";
import { GetApiData } from "../Get/ApiData";
import DeleteThanatomorphose from "../Delete/Thanatomorphose_MDF";

var _ = require("lodash");

export async function UpdateThanatomorphose_MDF(headers) {
  const _thanato = await GetApiData("THANATOMORPHOSE", headers);

  if (_thanato.Message !== undefined) {
    return _thanato;
  }

  return await DeleteThanatomorphose().then(() => {
    var drops = [];
    _.forEach(_thanato, (thanato) => {
      drops.push({
        IDTHANATOMORPHOSE: thanato.IDTHANATOMORPHOSE,
        LIBELLE: thanato.LIBELLE.trim(),
        ARCHIVER: thanato.ARCHIVER === 1,
        ORDRE: thanato.ORDRE,
      });
    });

    return db
      .open()
      .then(() => {
        return db.THANATOMORPHOSE.bulkAdd(drops)
          .then(() => {
            return "";
          })
          .catch((err) => {
            return handleError(err);
          });
      })
      .catch((err) => {
        return handleError(err);
      });
  });
}
